export default __webpack_public_path__ + "static/media/sustainability.46882a6f.svg";